import axios from '@/libs/api.request'
import config from '@/config'

const baseUrl = config.baseToolsUrl + '/jenkins/api/v1/'

export const getJenkins = (params) => {
  return axios.request({
    url: baseUrl + 'jenkins/',
    params: params,
    method: 'get'
  })
}

export const getJenkinsAllList = (params) => {
  return axios.request({
    url: baseUrl + 'jenkins_all_list/',
    params: params,
    method: 'get'
  })
}

export const changeJenkins = (data, id) => {
  let url = baseUrl + 'jenkins/'
  let method = 'post'
  if (id) {
    url += id + '/'
    method = 'put'
  }
  return axios.request({
    url: url,
    data: data,
    traditional: true,
    method: method
  })
}

export const detailJenkins = (id) => {
  return axios.request({
    url: baseUrl + 'jenkins/' + id + '/',
    method: 'get'
  })
}

export const deleteJenkins = (id) => {
  return axios.request({
    url: baseUrl + 'jenkins/' + id + '/',
    method: 'delete'
  })
}

export const logicDeleteJenkins = (id) => {
  return axios.request({
    url: baseUrl + 'jenkins/' + id + '/logic_delete/',
    method: 'delete'
  })
}

export const getJenkinsJobs = (id, params) => {
  return axios.request({
    url: baseUrl + 'jenkins/' + id + '/jobs/',
    params: params,
    method: 'get'
  })
}

export const getJenkinsJobDetail = (id, jobName) => {
  return axios.request({
    url: baseUrl + 'jenkins/' + id + '/job_detail/',
    params: { job_name: jobName },
    method: 'get'
  })
}

export const getJenkinsBuildConsole = (id, jobName, buildNumber) => {
  return axios.request({
    url: baseUrl + 'jenkins/' + id + '/build_console/',
    params: { job_name: jobName, build_number: buildNumber },
    method: 'get'
  })
}

export const getJenkinsViews = (id) => {
  return axios.request({
    url: baseUrl + 'jenkins/' + id + '/views/',
    method: 'get'
  })
}

export const getJenkinsQueueItem = (id, queueNumber) => {
  return axios.request({
    url: baseUrl + 'jenkins/' + id + '/queue_item/',
    params: { queue_number: queueNumber },
    method: 'get'
  })
}

export const buildJenkinsJob = (id, jobName, parameter) => {
  let data = {
    job_name: jobName
  }
  if (parameter) {
    data.parameter = parameter
  }
  return axios.request({
    url: baseUrl + 'jenkins/' + id + '/build/',
    data: data,
    traditional: true,
    method: 'post'
  })
}

export const buildJenkinsAllJob = (id, jobList) => {
  let data = {
    job_list: jobList
  }
  return axios.request({
    url: baseUrl + 'jenkins/' + id + '/all_build/',
    data: data,
    traditional: true,
    method: 'post'
  })
}

export const getJenkinsBuildQueueList = (id) => {
  return axios.request({
    url: baseUrl + 'jenkins/' + id + '/build_queue_list/',
    method: 'get'
  })
}

export const cancelJenkinsBuildQueue = (id, queueId) => {
  return axios.request({
    url: baseUrl + 'jenkins/' + id + '/cancel_queue/',
    data: { queue_id: queueId },
    method: 'post'
  })
}

export const getJenkinsRunningBuildList = (id) => {
  return axios.request({
    url: baseUrl + 'jenkins/' + id + '/running_build_list/',
    method: 'get'
  })
}

export const stopBuildJenkinsJob = (id, jobName, number) => {
  let data = {
    job_name: jobName,
    number: number
  }
  return axios.request({
    url: baseUrl + 'jenkins/' + id + '/stop_build/',
    data: data,
    traditional: true,
    method: 'post'
  })
}

export const getJenkinsJobLogs = (jenkinsId, jobName) => {
  return axios.request({
    url: baseUrl + 'jenkins_job_logs/',
    params: { jenkins: jenkinsId, job_name: jobName },
    method: 'get'
  })
}
